import { Component, OnInit, OnDestroy, inject } from '@angular/core'
import { UserService } from '@aifs-shared/user/user.service'
import { TermsAndConditions } from '@aifs-shared/user/terms-and-conditions'
import { TrackerTaskComponent } from '@aifs-shared/tracker/tracker-task.component';
import { ITaskProvider } from '@aifs-shared/tracker/task-provider';
import { CfLoaderComponent } from '@ui/cf-loader/cf-loader.component';
import { TrackerButtonComponent } from "@aifs-shared/tracker/tracker-button.component";

@Component({
    templateUrl: './public-terms-and-conditions.component.html',
    styleUrls: [
        './public-terms-and-conditions.component.scss',
    ],
    imports: [CfLoaderComponent, TrackerButtonComponent],
})
export class PublicTermsAndConditionsComponent extends TrackerTaskComponent implements OnInit, OnDestroy, ITaskProvider {
    private userService = inject(UserService);

    constructor() {
        super();
        this.requiresTask = false;

        let u = this.userService.isLoggedIn;
        // console.log(`Looking for terms -- logged in? ${u}`);
        this.setPreviousEnabled(!u);
    }

    override ngOnInit() {
        super.ngOnInit();


        this.loading = true;
        this.userService
            .getLatestTermsAndConditions()
            .subscribe({
                next: (terms: TermsAndConditions) => this.storeTerms(terms),
                error: (error: any) => {
                    this.pageError(<any>error)
                    this.loading = false;
                }
            });
    }

    override ngOnDestroy() {
        super.ngOnDestroy();
    }

    override initialise(): void {
    }

    override stepPrevious(): boolean {
        history.back();
        return true;
    }

    /**
     * Extract the returned terms
     * @param terms (TermsAndConditions) - returned terms
     */
    storeTerms(terms: TermsAndConditions): void {
        // console.info(`Store Terms`);
        // console.info(`TermsID: ${terms.agreedId}`);

        this.terms = terms;
        this.termsText = terms.termsBody;

        this.loading = false;
    }

    loading = true;

    // The actual terms and conditions we're displaying
    title: string = '';
    terms?: TermsAndConditions;
    termsText?: string;
}